import { TSize } from 'app/services/api5-service/api.interface';

/**
 * Get font size from size type
 *
 * @param size
 */
export function getFontSize(size?: TSize): string | undefined {
  switch (size) {
    case 'h1':
      return '25px';
    case 'h2':
      return '18px';
    case 'h3':
      return '16px';
    case 'h4':
      return '14px';
    case 'h5':
      return '12px';
    default:
      return undefined;
  }
}
